import "react-toastify/dist/ReactToastify.css";
import { http_api } from "../../leadg-api";
const getAllOrigins = () => {
    return http_api.get(`origins`);
};
const getOriginById = (id) => {
    return http_api.get(`origins/${id}`);
};
const createOrigin = (input) => {
    return http_api.post("origins", input);
};
const updateOrigin = (input) => {
    return http_api.put(`origins/${input.id}`, input);
};
const deleteOriginById = (id) => {
    return http_api.delete(`origins/${id}`);
};
const OriginApi = {
    getAllOrigins,
    getOriginById,
    createOrigin,
    updateOrigin,
    deleteOriginById
};
export default OriginApi;
